import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getIsMobileTraffic } from 'selectors/shared/mobileTraffic'
import { isLimitedContext } from 'selectors/siteContext'
import { Actions as AlgoliaActions } from 'actions/algolia'
import { getArtworkProductUrl, getArtworkHasOpenEditions } from '../selectors'
import { getCollectionPrintsView, getCollectionTitle } from '../selectors/collection'
import { getUserID } from 'selectors/user/session'
const mapStateToProps = createStructuredSelector({
  artworkProductUrl: (store, ownProps) =>
    getArtworkProductUrl(ownProps.artwork ? ownProps.artwork.artId : 0)(store),
  isLimited: isLimitedContext,
  isMobileTraffic: getIsMobileTraffic,
  hasOpenEditions: (store, ownProps) =>
    getArtworkHasOpenEditions(ownProps.artwork ? ownProps.artwork.artId : 0)(store),
  isPrintsViewCollection: getCollectionPrintsView,
  title: getCollectionTitle,
  userID: getUserID,
})

const mapDispatchToProps = (dispatch) => ({
  algoliaEvent: (payload: Record<string, any>) => dispatch(AlgoliaActions.EVENT(payload)),
})

export type ConnectorProps = {
  algoliaEvent: (...args: Array<any>) => any
  artworkProductUrl: string
  isLimited: boolean
  isMobileTraffic: boolean
  hasOpenEditions: boolean
  isPrintsViewCollection: boolean
  userID: number
}
export default connect(mapStateToProps, mapDispatchToProps) // Component Calls Connect
